import { useOutletContext } from 'react-router-dom';
import Hero from '@/components/Hero';
import WorldsMatrix from '@/components/WorldsMatrix';
import Marquee from '@/components/Marquee';
import AppsShowcase from '@/components/AppsShowcase';
import BooksVault from '@/components/BooksVault';
import Doctrines from '@/components/United99Portal';
import ResearchPortal from '@/components/ResearchPortal';
import MindStream from '@/components/MindStream';
import Manifesto from '@/components/Manifesto';
import Newsletter from '@/components/Newsletter';

export default function Home() {
  const { scrollTo } = useOutletContext();
  return (
    <main>
      <Hero onNavigate={scrollTo} />
      <WorldsMatrix onNavigate={scrollTo} />
      <Marquee />
      <Doctrines />
      <AppsShowcase />
      <BooksVault />
      <Marquee />
      <ResearchPortal />
      <MindStream />
      <Manifesto />
      <Newsletter />
    </main>
  );
}
